import React, {useState} from "react";
import {Card, Form, InputGroup} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { login, authentication_error } from "../_redux/_actions/authentication.actions";
import logo from "../images/SE-BPP-Login.png";
import newLogo from "../images/logo/SEHQC-Logo-Horizontal-Color-Clear.svg";
// import aafpLogo from "../images/AAFP_logo.png";
// import prismaLogo from "../images/prismaLogo.png";
// import stjudeLogo from "../images/stjude.png";
import styles from "./login_page.module.scss";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { isValidEmail,isSingleSignOnEmail } from "../_helpers/misc_functions";
import ErrorMessage from "./ErrorMessage";
import SuccessMessage from "./SuccessMessage";
import SubmitButton from "./SubmitButton";
import { useNavigate } from "react-router-dom";
import HubspotSupportWidget from "../MainPage/HubspotSupportWidget";

const LoginPage = (props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const prefilled_code = params.get('code') ?? '';
  const navigate = useNavigate();

  // Check if the query param "code" exists
  const hasCodeQueryParam = prefilled_code.trim() !== '';

  // Check if the last page (if you're storing it) was '/register'
  // Adjust the property name based on how you pass this info (e.g. lastPath or from)
  const cameFromRegister = location.state?.lastPath === 'register';

  // Determine if the registration link should be shown
  const showRegistrationLink = hasCodeQueryParam || cameFromRegister;

  const [email, setEmail ] = useState(params.get('email') ?? '');
  const [redirectPathname, ] = useState(params.get('redirect_url'))
  const [password, setPassword] = useState('');
  const {login, authentication_error} = props;

  if (params.get('error')) authentication_error(params.get('error'));
  const forgotPasswordLocation = Object.assign({}, location, { pathname: '/forgot-password', search: params.toString() })
  const singleSignOnLocation = Object.assign({}, location, { pathname: '/single-sign-on', search: params.toString() })
  // const registerLocation = Object.assign({}, location, { pathname: '/register', search: params.toString() })

  const handleEmailChange = e => {
    setEmail(e.target.value);
  }

  const handlePasswordChange = e => {
    setPassword(e.target.value);
  }

  const handleSubmit = async event => {
    event.preventDefault();

    if (!isValidEmail(email)) {
      authentication_error("Please enter valid email address.");
      return;
    }

    if (isSingleSignOnEmail(email)) {
      authentication_error("Please login through SSO");
      navigate(singleSignOnLocation);
      return;
    }

    // remove redirect_url from being included in redirect_search (aka the query params after login)
    delete params.delete('redirect_url');
    const redirectSearch = params.toString();

    const redirectLocation = Object.assign(
      {},
      location,
      {
        pathname: redirectPathname ?? '/',
        search: redirectSearch
      });
    login({ email, password }, redirectLocation);
  };

  return (
    <Card className={styles.loginContainer}>
      <HubspotSupportWidget layout="fixed-layout"/>
      <Card.Header className={styles.header}>
        <Card.Img className={styles.logoImage} variant="top" src={logo}/>
      </Card.Header>


      {/*<Card.Title className={styles.title}>Burnout Prevention</Card.Title>*/}
      <div className={styles.inputContainer}>
        <Form
          className={`d-flex flex-column align-items-center ${styles.form}`}
          onSubmit={handleSubmit}
        >
          <ErrorMessage/>
          <SuccessMessage/>
          <Form.Group className={styles.formGroup} controlId="email">
            <InputGroup>
                <InputGroup.Text id="inputGroupPrepend"><FaEnvelope/></InputGroup.Text>
              <Form.Control
                autoFocus
                type="email"
                value={email}
                onChange={handleEmailChange}
                className={styles.formControl}
                placeholder={"Email"}
              />
            </InputGroup>
          </Form.Group>
          <Form.Group className={styles.formGroup} controlId="password">
            <InputGroup>
                <InputGroup.Text id="inputGroupPrepend"><FaLock/></InputGroup.Text>
              <Form.Control
                value={password}
                onChange={handlePasswordChange}
                type="password"
                placeholder={"Password"}
                className={styles.formControl}
              />
            </InputGroup>
          </Form.Group>
          <SubmitButton text={"Log in"} pendingText={"Logging In..."}/>
        </Form>
      </div>
      {
        showRegistrationLink &&
        <>
          <div style={{ textAlign: 'center' }}>{"Don't have an account?"}</div>
          <Link
            to={Object.assign({}, location, { pathname: '/register' })}
            className={styles.forgotPasswordLink} style={{marginTop: '0'}}
          >
            {"Click here to Register."}
          </Link>
        </>
      }
      <Link to={forgotPasswordLocation} className={styles.forgotPasswordLink}>
        {"Forgot your password?"}
      </Link>
      <Link to={singleSignOnLocation} className={styles.forgotPasswordLink}>
        {"Log in with SSO"}
      </Link>
      <Card.Footer className={styles.footer}>
        <a target={"_blank"} rel="noreferrer" href={"https://www.sehealthcaresolutions.com/"}>
          Powered By:
          <Card.Img className={styles.poweredByLogoImage} variant="top" src={newLogo}/>
        </a>
      </Card.Footer>
    </Card>

  );

}

const mapDispatchToProps = dispatch => ({
  login: (credentials, redirect) => dispatch(login(credentials, redirect)),
  authentication_error: (error) => dispatch(authentication_error(error))
})

export default connect(undefined, mapDispatchToProps)(LoginPage);